"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isProductDomain = exports.isMultiDomain = exports.hasDomainsInFlow = void 0;
/**
 * Domain utility functions - isolated to avoid import issues
 */

/**
 * Check if a specific product is a domain
 * @param {Object} instance The instance object containing all products
 * @param {string} product The product key to check
 * @returns {boolean} True if the product is a domain
 */
const isProductDomain = (instance, product) => {
  return instance?.[product]?.properties?.productType === 'domain';
};

/**
 * Check if the environment is a multi-domain
 * @param {Object} environment The environment object containing the domains
 * @returns {boolean} True if the environment is a multi-domain
 */
exports.isProductDomain = isProductDomain;
const isMultiDomain = environment => {
  return environment?.domains > 1;
};

/**
 * Check if the current flow contains any domain products
 * @param {Object} instance The instance object containing all products
 * @returns {boolean} True if any product in the instance is a domain
 */
exports.isMultiDomain = isMultiDomain;
const hasDomainsInFlow = instance => {
  if (!instance || typeof instance !== 'object') {
    return false;
  }
  return Object.values(instance).some(item => item?.properties?.productType === 'domain');
};
exports.hasDomainsInFlow = hasDomainsInFlow;